import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchPosts } from '../redux/postsSlice';
import { RootState, AppDispatch } from '../redux/store';
import { Table, TableHead, TableRow, TableCell, TableBody, Container, Typography } from '@mui/material';

const PostList = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const posts = useSelector((state: RootState) => state.posts.list);

  useEffect(() => {
    dispatch(fetchPosts());
  }, [dispatch]);

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Posts
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>Body</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {posts.map((post: any) => (
            <TableRow key={post.id} hover onClick={() => navigate(`/post/${post.id}`)} style={{ cursor: 'pointer' }}>
              <TableCell>{post.title}</TableCell>
              <TableCell>{post.body}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Container>
  );
};

export default PostList;
